import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';
        case 'dato':
            return 'adresse';

        case 'adresse':
            return 'aarsag';

        case 'aarsag':
            return 'beskriv-skaden';

        case 'beskriv-skaden':
            return 'skete-skaden-under-reparation';

        case 'skete-skaden-under-reparation':
            if (getValueOrDefault(formConfig, formValues, 'isDamageCausedUnderRepair').value === 'y') {
                return 'om-genstande';
            }

            return 'skyldes-skaden-en-fejl';

        case 'skyldes-skaden-en-fejl':
            return 'om-genstande';

        case 'om-genstande':
            return 'indhentning-af-tilbud';

        case 'indhentning-af-tilbud':
            if (getValueOrDefault(formConfig, formValues, 'erderindhentetettilbudpudbedringafskaden').value === 'Ja') {
                return 'tilbud-og-pris';
            }
            return 'dokumentation';

        case 'tilbud-og-pris':
            return 'dokumentation';

        case 'dokumentation':
            return 'virksomhedsoplysninger';

        case 'virksomhedsoplysninger':
            return 'forsikringsmaegler';

        case 'forsikringsmaegler':
            return 'om-virksomheden';

        case 'om-virksomheden':
            return 'andet-selskab';

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'i-hvilket-selskab';
            }

            return 'om-dig';

        case 'i-hvilket-selskab':
            return 'om-dig';

        case 'om-dig':
            return 'resume';

        case 'resume':
            return undefined;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
